/*
 * @Description:
 * @Author: yaoyc
 * @Date: 2020-08-26 11:04:51
 * @LastEditTime: 2020-12-30 11:06:26
 * @LastEditors: yaoyc
 */
import { createBEM } from './bem';
import { createComponent } from './component';
import { createI18N } from './i18n';
export function createNamespace(name) {
  var componentName = 'yj-' + name;
  name = 'van-' + name;
  return [createComponent(componentName), createBEM(name), createI18N(name)];
}